import React, { FC } from 'react';
import { Asset, CloseIcon, Button, ButtonProps } from '@clearcover/atlas';

import styles from './styles.module.css';

type ClearFilterButtonProps = ButtonProps;

export const ClearFilterButton: FC<ClearFilterButtonProps> = props => (
  <Button
    size="sm"
    variant={'danger-secondary'}
    className={styles.clear}
    {...props}
  >
    <Asset
      className={styles.clearIcon}
      icon={CloseIcon}
      height={10}
      width={10}
      description="Clear"
    />
    {props.children}
  </Button>
);
